import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import UserContext from "../../context/User.context";
import Button from "@pds-react/button";
import ReactModal from "react-modal";
import "./Header.scss";
import "../Utilities/Modal/ModalStylesBuiltIn.css";
import modalStyles from "../Utilities/Modal/ModalSyles";
import { Col, Row } from "@pds-react/grid";

function Header() {
  const { loggedIn, name } = useContext(UserContext);
  const [modalOpen, setModal] = useState(false);

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleTicket = () => {
    const ticketUrl = "https://servicemgmt.principal.com/CherwellPortal/ServiceDeskOnline?_=3bd096b6#0";
    window.open(ticketUrl, "_blank", "noreferrer");
  };

  return (
    <nav data-testid="Header" className="navbar navbar-default">
      <div className="container-fluid">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#nav-collapse"
            aria-expanded="false"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <Link className="navbar-principal-brand" to="/"></Link>
        </div>
        <div className="collapse navbar-collapse" id="nav-collapse">
          <ul className="nav navbar-nav">
            <li>
              <Link to="/">GMM Cash Sweep Dashboard</Link>
            </li>
            {loggedIn && (
              <>
                <li className="dropdown">
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                    Custody Accounts <i className="fa fa-angle-down"></i>
                  </a>
                  <ul className="dropdown-menu" role="menu">
                    <li>
                      <Link to="/custody-account-management">Custody Account Management</Link>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                    Date Files Received <i className="fa fa-angle-down"></i>
                  </a>
                  <ul className="dropdown-menu" role="menu">
                    <li>
                      <Link to="/date-files-received-management">Date Files Received Management</Link>
                    </li>
                  </ul>
                </li>
              </>
            )}
          </ul>
          {loggedIn && (
            <>
              <ul className="nav navbar-nav navbar-right">
                <li className="dropdown" data-testid={"modal-main"}>
                  <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                    {name} <i className="fa fa-angle-down"></i>
                  </a>
                  <ul className="dropdown-menu" role="menu">
                    <li data-toggle="modal" data-target=".bs-example-modal-std" data-testid="HelpLink">
                      <a
                        href="#"
                        onClick={() => {
                          setModal(true);
                        }}
                      >
                        Help
                      </a>
                    </li>
                    <li role="separator" className="divider"></li>
                    <li>
                      <a
                        href="#"
                        data-testid="SignOut"
                        onClick={(e) => {
                          e.preventDefault();
                          Auth.signOut();
                        }}
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ReactModal
                data-testid={`modal_testid`}
                id={`modal`}
                isOpen={modalOpen}
                contentLabel="Minimal Modal Example"
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                onRequestClose={() => handleCloseModal()}
                style={modalStyles({ center: false })}
              >
                <div className={"container"}>
                  <Row>
                    <Col sm={12} lg={12}>
                      <div className={"text-center"}>
                        <h3 className="modal-title" id="static-modal-label">
                          Help
                        </h3>
                      </div>
                      <hr />
                      <h5>For all issues please submit a ticket:</h5>
                      <div className={"text-center"}>
                        <Row>
                          <Col sm={12} lg={12}>
                            <Button data-testid={`modal_help_button`} variant="primary" onClick={handleTicket}>
                              Create ticket
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </ReactModal>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Header;
